export const GET_OFFERS_DATA = "GET_OFFERS_DATA";
export const GET_OFFERS_DATA_SUCCESS = "GET_OFFERS_DATA_SUCCESS";
export const GET_OFFERS_DATA_FAILURE = "GET_OFFERS_DATA_FAILURE";
export const GET_ARTICLES_DATA = "GET_ARTICLES_DATA";
export const GET_ARTICLES_DATA_SUCCESS = "GET_ARTICLES_DATA_SUCCESS";
export const GET_ARTICLES_DATA_FAILED = "GET_ARTICLES_DATA_FAILED";

export const DELETE_ARTICLE_AND_FAQS = "DELETE_ARTICLE_AND_FAQS";
